<template>
  <component
    :is="clickable ? 'button' : 'div'"
    :type="clickable ? 'button' : undefined"
    class="hw-bar-row"
    :class="{ 'hw-bar-clickable': clickable, active, 'hw-bar-muted': muted }"
    :style="{ '--hw-bar-cols': columns }"
    @click="onClick"
  >
    <span v-if="dot" class="hw-dot" :style="{ backgroundColor: dot }"></span>
    <span class="hw-bar-name hw-ellipsis"><slot name="name">{{ name }}</slot></span>
    <span class="hw-bar-track" :class="{ 'hw-bar-stacked': stacked }">
      <span v-for="segment in segments" :key="segment.key" class="hw-bar-fill" :style="{ width: shareWidth(segment.value, scale), backgroundColor: segment.color }"></span>
    </span>
    <strong v-if="value" class="hw-num">{{ value }}</strong>
    <span v-if="pill" class="hw-pill" :style="pillStyle">{{ pill }}</span>
    <slot name="extra" />
  </component>
</template>

<script setup>
import { computed, useSlots } from 'vue'
import { shareWidth } from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/hrWorkforce'

const props = defineProps({
  name: { type: String, default: '' },
  segments: { type: Array, required: true },
  scale: { type: Number, required: true },
  stacked: { type: Boolean, default: false },
  value: { type: String, default: '' },
  pill: { type: String, default: '' },
  pillStyle: { type: Object, default: () => ({}) },
  dot: { type: String, default: '' },
  nameWidth: { type: String, default: '160px' },
  clickable: { type: Boolean, default: false },
  active: { type: Boolean, default: false },
  muted: { type: Boolean, default: false }
})

const emit = defineEmits(['select'])

const slots = useSlots()

const columns = computed(() => [props.dot ? '12px' : '', props.nameWidth, 'minmax(0, 1fr)', props.value ? '48px' : '', props.pill ? '52px' : '', slots.extra ? 'auto' : ''].filter(Boolean).join(' '))

const onClick = () => {
  if (!props.clickable) return
  emit('select')
}
</script>

<style scoped src="./hrWorkforce.css"></style>

<style scoped>
.hw-bar-row {
  display: grid;
  grid-template-columns: var(--hw-bar-cols);
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 6px 8px;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  font-size: 0.85rem;
  color: #334155;
}
.hw-bar-clickable {
  cursor: pointer;
}
.hw-bar-clickable:hover:not(:disabled) {
  background: #f1f5f9;
}
.hw-bar-row.active {
  background: #f0fdfa;
  border-left-color: #0f766e;
}
.hw-bar-row:disabled {
  cursor: default;
}
.hw-bar-row:focus-visible {
  outline: 2px solid #0f766e;
  outline-offset: 2px;
}
.hw-bar-muted {
  opacity: 0.55;
}
.hw-bar-row .hw-dot {
  margin-right: 0;
}
.hw-bar-track {
  display: flex;
  height: 12px;
  border-radius: 6px;
  overflow: hidden;
  background: #f1f5f9;
}
.hw-bar-fill {
  display: block;
  height: 100%;
  border-radius: 6px;
}
.hw-bar-stacked {
  gap: 2px;
  height: 16px;
  border-radius: 8px;
}
.hw-bar-stacked .hw-bar-fill {
  border-radius: 4px;
}
@media (max-width: 575px) {
  .hw-bar-row {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 8px;
  }
  .hw-bar-name {
    flex: 1 1 0;
    min-width: 0;
  }
  .hw-bar-track {
    order: 1;
    flex-basis: 100%;
  }
}
</style>
